export default __webpack_public_path__ + "static/media/manage-handy-tap.1a4749b0.svg";